// rh-footer/rh-footer-social-link.js
import { createComponent } from '@lit/react';
import react from 'react';
import { RhFooterSocialLink } from '@rhds/elements/rh-footer/rh-footer-social-link.js';
export const FooterSocialLink = createComponent({
  tagName: 'rh-footer-social-link',
  elementClass: RhFooterSocialLink,
  react,
  events: {},
});
